import { useState, useEffect } from 'react';
import { loadDemoStatuses } from '../demo/demoData';

function useDecoyStatuses() {
  const [decoyStatuses, setDecoyStatuses] = useState({});
  const [userStatuses, setUserStatuses] = useState({});

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchStatuses = async () => {
    try {
      const data = await loadDemoStatuses('decoys');
      setDecoyStatuses(data?.decoyStatuses || {});
      setUserStatuses(data?.userStatuses || {});
    } catch (err) {
      setError('Failed to fetch decoy statuses: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatuses();
  }, []);

  const updateStatus = async (decoyName, enabled, userName = null) => {
    setLoading(true);
    try {
      if (userName) {
        setUserStatuses(prev => ({
          ...prev,
          [decoyName]: {
            ...(prev[decoyName] || {}),
            [userName]: { enabled }
          }
        }));
      } else {
        setDecoyStatuses(prev => ({
          ...prev,
          [decoyName]: { ...(prev[decoyName] || {}), enabled }
        }));
      }
      return true;
    } catch (err) {
      setError(`Failed to ${enabled ? 'enable' : 'disable'} ${decoyName}${userName ? ` for user ${userName}` : ''}: ${err.message}`);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { 
    decoyStatuses,
    userStatuses,
    loading, 
    error, 
    updateStatus,
    refreshStatuses: fetchStatuses 
  };
}

export default useDecoyStatuses; 